import {
  ICreateCompanyRequest,
  ICreateZoneResponse,
  IDeleteByIdRequest,
  IDeleteCompanyResponse,
  IGetAllCompaniesResponse,
  IGetByIdRequest,
  IGetCompanyByIdResponse,
  IPaginationRequest,
  IUpdateCompanyRequest,
  IUpdateCompanyResponse,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";
const prefix = PREFIX.masterData;
const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};

const URL_GET_ALL_COMPANY = getUrl("get-all-companies");
const URL_GET_COMPANY_BY_ID = getUrl("get-company-by-id");
const URL_CREATE_COMPANY = getUrl("create-company");
const URL_UPDATE_COMPANY = getUrl("update-company");
const URL_DELETE_COMPANY = getUrl("delete-company");

class CompanyApiService extends BaseApiService {
  public getAllCompanies = (request: IPaginationRequest) =>
    this.get<IGetAllCompaniesResponse>(URL_GET_ALL_COMPANY, {
      params: request,
    });
  public getCompanyById = (request: IGetByIdRequest) =>
    this.get<IGetCompanyByIdResponse>(URL_GET_COMPANY_BY_ID, {
      params: request,
    });
  public createCompany = (request: ICreateCompanyRequest) =>
    this.post<ICreateCompanyRequest, ICreateZoneResponse>(
      URL_CREATE_COMPANY,
      request
    );
  public updateCompany = (request: IUpdateCompanyRequest) =>
    this.put<IUpdateCompanyRequest, IUpdateCompanyResponse>(
      URL_UPDATE_COMPANY,
      request
    );
  public deleteCompany = (request: IDeleteByIdRequest) =>
    this.delete<IDeleteCompanyResponse>(URL_DELETE_COMPANY, {
      params: request,
    });
}

export default new CompanyApiService();
